<template>
  <b-card no-body>
    <div v-if="caption" slot="header" v-html="caption"></div>

    <b-card-body :class="{'p-0': noPadding}">
      <div v-if="isEmpty" class="no-data-container">
        <h5 class="mt-3">No data available</h5>
      </div>

      <div v-else class="custom-table">
        <vue-perfect-scrollbar><!-- instead of "responsive" for b-table -->
          <b-table :dark="darkMode"
                   :hover="hover"
                   :striped="striped"
                   :bordered="bordered"
                   :small="small"
                   :fixed="fixed"
                   :items="items"
                   :fields="computedFields"
                   :current-page="currentPage"
                   :per-page="perPage">

            <template v-if="cellClassHandler" #cell()="cell">
              <div :class="cellClassHandler(cell)">
                {{ cellFormatter ? cellFormatter(cell) : cell.value }}
              </div>
            </template>

          </b-table>
        </vue-perfect-scrollbar>

        <nav class="mt-3">
          <b-pagination :total-rows="totalRows"
                        :per-page="perPage"
                        v-model="currentPage"
                        @change="onPageChange"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons/>
        </nav>
      </div>

    </b-card-body>
  </b-card>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'

export default {
  name: 'c-table',
  inheritAttrs: false,
  components: {
    'vue-perfect-scrollbar': VuePerfectScrollbar,
  },

  props: {
    caption: {
      type: String,
      default: null
    },
    hover: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    currentPageExternal: {
      type: Number,
      default: () => 1,
    },
    perPage: {
      type: Number,
      default: 5
    },
    cellClassHandler: {
      // allows to add a class according to a given cell
      type: Function,
      default: null,
    },
    cellFormatter: {
      // allows to format all fields in rows
      type: Function,
      default: null,
    },
    sorting: {
      // when set to false, sorting is disabled for the whole table
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      currentPage: 1,
    }
  },
  computed: {
    ...mapGetters('gui', [
      'darkMode',
    ]),

    items() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items()
    },

    totalRows() {
      return this.getRowCount()
    },

    computedFields() {
      return this.fields.map(field => {
        if(typeof field === 'object' && !this.sorting) {
          let fieldCopy = {...field};
          delete fieldCopy.sortable;
          return fieldCopy
        }
        return field;
      });
    },

    isEmpty() {
      return !this.items.length;
    },
  },

  methods: {
    getRowCount: function () {
      return this.items.length
    },
    onPageChange: function (newValue) {
      // only user interaction events are possible here
      this.$emit('page-changed', newValue, Math.ceil(this.totalRows / this.perPage));
    },
  },

  watch: {
    currentPageExternal(newValue) {
      this.currentPage = newValue;
    },
  },
}
</script>

<style scoped lang="scss">
.no-data-container {
  min-height: 325px;
  text-align: center;
}

.custom-table {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  nav {
    margin: 0;

    ul {
      margin: 0;
    }
  }
}
</style>
